// extracted by mini-css-extract-plugin
export default {"profileWrapper":"avatar_profileWrapper__8yD5x","avatar":"avatar_avatar__qvQL9"};